import api, { warehousesApi } from './api';
import { Warehouse, WarehouseFilters, PaginatedWarehouseResponse } from '../types/warehouse';

export const getWarehouses = async (filters: WarehouseFilters = {}): Promise<Warehouse[]> => {
  try {
    const response = await warehousesApi.getWarehouses(filters);
    return response.warehouses;
  } catch (error) {
    console.error('Error fetching warehouses:', error);
    throw error;
  }
};

export const getWarehouseById = async (id: string): Promise<Warehouse> => {
  try {
    return await warehousesApi.getWarehouse(id);
  } catch (error) {
    console.error(`Error fetching warehouse with id ${id}:`, error);
    throw error;
  }
};

export default {
  getWarehouses,
  getWarehouseById
};